import { APICALL } from 'helper/api/api';
import { currencySign, SERVER_ERR, SOMETHING_ERR } from 'helper/Constant';
import BTNLoading from 'helper/my-com/BTNLoading';
import ConfirmDelete from 'helper/my-com/ConfirmDelete';
import { auth, defaultIMG, emptyIMG, formatdedDate, imgBaseURL, timeAgo, toastifyError, toastifySuccess } from 'helper/Utility';
import React from 'react'
import { useState } from 'react';
import {
    Col,
    Row,
    Table,
} from "react-bootstrap";
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import RateBtn from 'views/Component/RateBtn';

const Booking = () => {
    const [bookingList, setBookingList] = useState([]);
    useEffect(() =>{
        getBookingFun()
    },[])
    const getBookingFun = async () => {
        try {
            const params = {role : "User"}
            const res = await APICALL("admin/getAllBookings", "post", params)
            if (res?.status) {
                setBookingList(res?.data)
            } else {
                setBookingList([])
            }
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <>
         <div className=" selller_edit_sellpromain">
                <div className="nn_edit_proname">Bookings</div>
                <div className="seller_edit_sellpro">
                    {
                        bookingList?.length > 0 ?
                            <Row className="seller_edit_sellpro_inner">
                                <div className="nn_order_details-pay table-responsive p-0">
                                    <Table className="mb-0">
                                        <thead>
                                            <tr>
                                                <th>Product Title</th>
                                                <th>Price</th>
                                                <th>Date</th>
                                                <th>Slot</th>
                                                <th>Vendor</th>
                                                <th className="text-end">Booking Date</th>
                                                <th className="text-end">Rate</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {bookingList?.map((item, idx) => (
                                                <>
                                                    <tr>
                                                        <td width="30%">
                                                            <div className="imgwithtitle">
                                                                <img src={item?.productId?.gallery?.length > 0 ? imgBaseURL() + item?.productId?.gallery[0] : defaultIMG} alt="" />{item?.productId?.title}
                                                            </div>
                                                        </td>
                                                        <td>{currencySign}{item?.total}</td>
                                                        <td>{formatdedDate(item?.date)}</td>
                                                        <td>{item?.slot}</td>
                                                        <td>{item?.vendorId?.fullName}</td>
                                                        <td className="text-end">{timeAgo(item?.createdAt)}</td>
                                                        <td  className="text-end"> {!item?.isRating ?<RateBtn className="" data={item} callFun={getBookingFun}/>:<p className='alredy_raded'>Rated</p>} </td>
                                                    </tr>
                                                </>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </Row>
                            :
                            <div className="nn_empty_tab text-center">
                                <img src={emptyIMG} alt="Empty" />
                                <p>
                                      <strong className="text-black">You have't been booked.. yet.</strong><br/>When the party planners find you, your bookings will show up here!
                                    </p>
                            </div>
                    }
                </div>
            </div>
        </>
    )
}

export default Booking